const Form = () => {

	let setClass = (elem) => {
		if (elem.value) {
			elem.parentNode.classList.add('form-has-value');
		} else {
			elem.parentNode.classList.remove('form-has-value');
		}
	};

	Array.from(document.querySelectorAll('.form-input-field, .form-textarea-field')).forEach(field => {
		field.addEventListener('change', (e) => {
			setClass(e.target);
		});
		setClass(field);
	});
};

export default Form;
